import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 *     get() // returns group, selected group or all permissions
 *     setSingle( payload: { key: string, group: object of permissions } )
 *     setAll(payload : { all permissions groups } )
 *
 * @param {string || [string] } permissionGroup
 */
export default function usePermissions(permissionGroup) {
    const store = useStore();

    const initList = (permissionGroup = permissionGroup) => {
        if (typeof permissionGroup === 'string') {
            return store.getters['UserPermissionStore/GET_SINGLE_PERMISSION'](permissionGroup);
        }

        if (Array.isArray(permissionGroup)) {
            const obj = {};
            permissionGroup.forEach((group) => {
                obj[group] = store.getters['UserPermissionStore/GET_SINGLE_PERMISSION'](group);
            });
            return obj;
        }

        return store.getters['UserPermissionStore/GET_ALL_PERMISSIONS'];
    };

    const permissionList = computed(() => ({
        list: initList(permissionGroup),
        get: () => computed(() => permissionList.value.list),
        setSingleGroup: (payload) => {
            if (!payload) return;
            store.commit('UserPermissionStore/SET_SINGLE_PERMISSION', payload);
        },
        setAllGroups: (payload) => {
            if (!payload) return;
            store.commit('UserPermissionStore/SET_ALL_PERMISSIONS', payload);
        },
    }));

    return {
        get: permissionList.value.get,
        setGroup: permissionList.value.setSingleGroups,
        setAll: permissionList.value.setAllGroups,
    };
}
